export default "__VITE_ASSET__d0fe64ca__"